import CreditOfferOptions from './credit-offer-list';

export default CreditOfferOptions;
